import React from 'react';
import { Quote, Star } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { useLanguage } from '@/contexts/LanguageContext';

export const TrainingTestimonials = () => {
  const { language } = useLanguage();

  const testimonials = language === 'fr' ? [
    {
      quote: "La formation Gaius a transformé notre approche de la recherche juridique. En 4 semaines, l'ensemble de notre équipe contentieux utilise l'IA au quotidien avec confiance.",
      author: "Associé, cabinet d'affaires — Paris",
      role: "Équipe de 12 avocats formés",
      stars: 5,
    },
    {
      quote: "Ce qui distingue Gaius, c'est la double compétence avocat-tech. Les exercices sur nos propres dossiers ont rendu la formation immédiatement actionnable.",
      author: "Directrice juridique, groupe industriel",
      role: "Formation sur-mesure de 8 juristes",
      stars: 5,
    },
    {
      quote: "Après la formation prompt engineering, notre temps de rédaction de notes a diminué de 40%. Le ROI est évident dès la première semaine.",
      author: "Counsel, cabinet international",
      role: "Programme Prompt Engineering Avancé",
      stars: 5,
    },
  ] : [
    {
      quote: "Gaius training transformed our approach to legal research. Within 4 weeks, our entire litigation team was confidently using AI daily.",
      author: "Partner, Business Law Firm — Paris",
      role: "Team of 12 lawyers trained",
      stars: 5,
    },
    {
      quote: "What sets Gaius apart is the dual lawyer-tech expertise. Exercises on our own cases made the training immediately actionable.",
      author: "General Counsel, Industrial Group",
      role: "Custom training for 8 in-house lawyers",
      stars: 5,
    },
    {
      quote: "After the prompt engineering program, our memo drafting time dropped by 40%. The ROI was clear from week one.",
      author: "Counsel, International Firm",
      role: "Advanced Prompt Engineering Program",
      stars: 5,
    },
  ];

  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-foreground mb-4 text-center">
          {language === 'fr' ? 'Ils ont suivi nos formations IA juridique' : 'They Completed Our Legal AI Training'}
        </h2>
        <p className="text-muted-foreground text-center mb-12 max-w-2xl mx-auto">
          {language === 'fr'
            ? 'Des professionnels du droit qui ont accéléré leur maîtrise de l\'IA avec Gaius, et gagné en productivité pour mieux servir leurs clients.'
            : 'Legal professionals who accelerated their AI mastery with Gaius.'}
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="bg-white border-border hover:shadow-lg transition-shadow">
              <CardContent className="pt-6">
                <Quote className="w-8 h-8 text-primary/30 mb-4" />
                <div className="flex gap-0.5 mb-4">
                  {Array.from({ length: testimonial.stars }).map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-primary text-primary" />
                  ))}
                </div>
                <blockquote className="text-muted-foreground mb-6 italic leading-relaxed">
                  "{testimonial.quote}"
                </blockquote>
                <div className="border-t border-border pt-4">
                  <p className="font-semibold text-foreground text-sm">{testimonial.author}</p>
                  <p className="text-xs text-muted-foreground mt-1">{testimonial.role}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
